import VideocamIcon from '@mui/icons-material/Videocam';
import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import { Box, Button, Typography } from '@mui/material';
import { useEffect, useRef } from 'react';

import { useMediaDevicesContext } from '../../providers/media-devices-context';

export const CameraPreview = () => {
  const { stream, error, isVideoEnabled, toggleVideo } =
    useMediaDevicesContext();
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const videoEl = videoRef.current;
    if (!videoEl || !stream) {
      return;
    }

    videoEl.srcObject = stream;

    return () => {
      videoEl.srcObject = null;
    };
  }, [stream]);

  return (
    <Box
      sx={{
        position: 'relative',
        aspectRatio: '16/9',
        bgcolor: 'grey.600',
        borderRadius: 2,
        overflow: 'hidden',
      }}
    >
      {error ? (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography>{error.message}</Typography>
        </Box>
      ) : (
        <video
          ref={videoRef}
          autoPlay
          muted
          playsInline
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      )}
      <Box
        sx={{
          position: 'absolute',
          bottom: 8,
          left: 8,
          display: 'flex',
          gap: 1,
        }}
      >
        <Button
          variant='contained'
          size='small'
          sx={{
            minWidth: 0,
            p: 1,
            borderRadius: '50%',
            bgcolor: 'rgba(255, 255, 255, 0.2)',
            backdropFilter: 'blur(8px)',
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.3)',
            },
          }}
          onClick={toggleVideo}
        >
          {isVideoEnabled ? <VideocamIcon /> : <VideocamOffIcon />}
        </Button>
      </Box>
    </Box>
  );
};
